/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
    TextField,
    Grid,
    Box,
    IconButton
} from '@mui/material';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Delete02Icon,AddCircleIcon } from '@hugeicons-pro/core-stroke-rounded';
import { ERR_EMAIL_INVALID, LABEL_BTN_CANCEL, NEW_USER_ERROR_INVALID_FIRST_NAME, NEW_USER_ERROR_INVALID_LAST_NAME } from 'src/constants/constant';
import { useSelector } from 'react-redux';
import type { BrandApiResponse, RootState } from '../types/types';
import { addSeedList } from 'src/services/seedListService';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import * as EmailValidator from 'email-validator';

interface PropsType {
    onClose: () => void;
    onRefresh: () => void;
}

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Please enter the title'),
    seeds: Yup.array()
        .of(
            Yup.object().shape({
                firstName: Yup.string().required('Please enter the first name').matches(
                      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
                      NEW_USER_ERROR_INVALID_FIRST_NAME
                    ),
                lastName: Yup.string().required('Please enter the last name').matches(
                      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
                      NEW_USER_ERROR_INVALID_LAST_NAME
                    ),
                email: Yup.string().email('Invalid email').required('Please enter the email').test(
                        'is-valid-email',
                        ERR_EMAIL_INVALID,
                        (value) => value === '' || EmailValidator.validate(value),
                      ),
            })
        )
        .min(1, 'At least one seed is required'),
});

function AddSeedList({onClose, onRefresh}: PropsType): JSX.Element {

    const [isLoading, setIsLoading] = React.useState<boolean>(false);   
    const { user } = useSelector((state: RootState) => state.auth);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            title: '',
            seeds: [{ firstName: '', lastName: '', email: '' }],
        },
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'seeds',
    });

    const onSubmit = (data: any): void => {
        setIsLoading(true);
        const finalRequest = {
          clientId: user?.clientId ?? 0,
          title: data.title,
          createdBy: user?.id ?? 0,
          seeds: data.seeds,
        };

        addSeedList(finalRequest)
            .then((response: BrandApiResponse) => {
                if (response.status === 200 && response.data.result === 1) {
                    NotificationManager.success('Seed list added successfully');
                    onRefresh();
                } else {
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                    const error = response.data.messages[0].message || 'Failed to add seed list';
                    NotificationManager.error(error);
                }
            })
            .catch((error) => {
                console.error('Error adding seed list:', error);
                NotificationManager.error('An error occurred while adding the seed list');
            })
            .finally(() => {
                setIsLoading(false);
            });

        console.log('Final Request:', data);
    };

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            void handleSubmit(onSubmit)(e);
        }} noValidate>
            <div className="relative px-[16px] pt-[10px] pb-[50px]">
               

                    {/* Title */}
                      <Box mb={4}>
                        <Controller
                            name="title"
                            control={control}
                            render={({ field }) => (
                                <>
                                <TextField
                                    {...field}
                                    fullWidth
                                    label="Title*"
                                    variant="outlined"
                                    error={!!errors.title}
                                />
                                {errors.title && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                        {errors.title?.message} 
                                    </div>
                                )}
                                </>
                            )}
                        />
                    </Box>

                    {/* Seeds Grid */}
                    {fields.map((item, index) => (
                        <Grid container spacing={2} alignItems="center" key={item.id} >
                            <Grid item xs={12} sm={3}>
                                <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.firstName`}
                                    control={control}
                                    defaultValue={item.firstName}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            label="First Name*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.firstName}
                                        />
                                         {errors.seeds?.[index]?.firstName && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                        {errors.seeds?.[index]?.firstName?.message} 
                                    </div>
                                )}
                                        </>
                                    )}
                                />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                 <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.lastName`}
                                    control={control}
                                    defaultValue={item.lastName}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            label="Last Name*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.lastName}
                                        />
                                        {errors.seeds?.[index]?.lastName && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                        {errors.seeds?.[index]?.lastName?.message} 
                                    </div>
                                )}
                                        </>
                                    )}
                                />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.email`}
                                    control={control}
                                    defaultValue={item.email}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            label="Email*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.email}
                                        />
                                        {errors.seeds?.[index]?.email && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                {errors.seeds?.[index]?.email?.message}
                                            </div>
                                        )}
                                        </>
                                    )}
                                />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                 <div className="mb-[30px]">
                                <IconButton
                                    color="error"
                                    onClick={() => remove(index)}
                                    disabled={fields.length === 1}
                                >
                                    <HugeiconsIcon
                                        icon={Delete02Icon}
                                        size={20}
                                        color="#de3339"
                                        // strokeWidth={0.2}
                                    />
                                </IconButton>
                                {
                                    fields.length === index + 1 &&
                                    <IconButton
                                        onClick={() => append({ firstName: '', lastName: '', email: '' })}
                                    >
                                        <HugeiconsIcon
                                            icon={AddCircleIcon}
                                            size={20}
                                            color="#3a3a3a"
                                            strokeWidth={0.2}
                                        />
                                    </IconButton>
                                }
                                </div>
                            </Grid>
                        </Grid>
                    ))}

                 

                
            </div>
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={onClose}>{LABEL_BTN_CANCEL}</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]">{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                </div>
            </div>
        </form>
    );
}

export default AddSeedList;
